import React from 'react';
import { Button, Input } from '@quyva/shared-ui';
import {
    faCheck,
    faCircleCheck,
    faClose,
    faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TelegramSocketEvent } from './enums';

export const GroupCreationForm = ({
    user,
    socket,
    botName,
    repository,
    groupName,
    setGroupName,
    setShowTelegramForm,
    setIsLoading,
    setLoadingText,
    onRefreshVirtualRepos,
}) => {
    return (
        <div className='w-full h-full flex flex-col'>
            <div className='flex items-center mb-6'>
                <div className='w-1/2 font-semibold text-texts-secondary300'>
                    <label htmlFor='groupName'>Group Name</label>
                </div>

                <div className='w-full'>
                    <div className='relative'>
                        <Input
                            type={'text'}
                            value={groupName}
                            placeholder={`${repository.name} Group`}
                            disabled={false}
                            onChange={(e) => {
                                setGroupName(e.target.value);
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className='w-full flex items-center text-sm mb-4'>
                <FontAwesomeIcon
                    icon={faCircleCheck}
                    className='mr-2 text-icons-success'
                    title='Information'
                />
                <span>
                    Telegram bot has been successfully enabled on your
                    repository. Creating group is optional.
                </span>
            </div>

            <div className='w-full flex items-center text-sm mb-4'>
                <FontAwesomeIcon
                    icon={faInfoCircle}
                    className='mr-2 text-texts-tertiary400'
                    title='Information'
                />
                <span>
                    This group will be created in your telegram account, also
                    <span className='mx-1 font-semibold'>{botName}</span>will be
                    added automatically to this group.
                </span>
            </div>

            <div className='w-full flex-col items-center text-sm mb-4'>
                <FontAwesomeIcon
                    icon={faInfoCircle}
                    className='mr-2 text-texts-tertiary400'
                    title='Information'
                />
                If you skip this step, you will have to carry few steps
                manually.
                <div className='flex-col items-center text-sm ml-6'>
                    <li>Manually create a group in your telegram account</li>
                    <li>
                        Manually Add
                        <span className='mx-1 font-semibold'>{botName}</span>
                        to the group
                    </li>
                    <li>
                        Provide the {botName} with
                        <span className='mx-1 font-semibold'>
                            Admin privileges
                        </span>
                        in the group
                    </li>
                </div>
            </div>

            <div className='w-full flex justify-end items-center'>
                <Button
                    text={'Close'}
                    icon={faClose}
                    type={'danger'}
                    hoverText={'Cancel Telegram Integration'}
                    onClick={() => {
                        const data = {
                            userMail: user.email,
                            repoName: repository.name,
                            repoId: repository.repoid,
                        };
                        socket.emit(
                            TelegramSocketEvent.DELETE_USER_SESSION,
                            data
                        );

                        setShowTelegramForm(false);
                        
                        if (onRefreshVirtualRepos) {
                            onRefreshVirtualRepos();
                        }
                    }}
                    className='mr-6'
                />

                <Button
                    text={'Create'}
                    icon={faCheck}
                    type={'success'}
                    hoverText={'Create a new group'}
                    onClick={() => {
                        setLoadingText('Creating Group...');
                        setIsLoading(true);
                        const data = {
                            userMail: user.email,
                            repoName: repository.name,
                            repoId: repository.repoid,
                            groupName: groupName,
                        };
                        socket.emit(TelegramSocketEvent.GROUP_CREATION, data);
                    }}
                    disabled={!groupName.trim() ? true : false}
                />
            </div>
        </div>
    );
};
